import React, {useState} from 'react';
import {Form} from "react-bootstrap";
import {StripePriceObject} from "./stripePriceObject";

export default function useDownSell(mainPrice: StripePriceObject & { downsell?: StripePriceObject }) {
    const [showDownSell, setShowDownSell] = useState(false);
    const price = mainPrice?.downsell && showDownSell ? mainPrice.downsell : mainPrice;

    return {
        hasDownSell: Boolean(mainPrice?.downsell),
        price,
        setShowDownSell,
        showingDownSell: showDownSell,
        switchComponent: mainPrice?.downsell ? (
            <Form.Switch // prettier-ignore
                type="switch"
                id={`custom-switch-${mainPrice.id}`}
                className="text-sm mb-0 d-inline-block"
                label={showDownSell ? 'Billed monthly' : 'Billed annually'}
                checked={!showDownSell}
                onClick={(e) => {
                    e.stopPropagation();
                }}
                onChange={(e) => {
                    setShowDownSell(!e.target.checked);
                }}
            />
        ) : null,
    };
}
